// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_rehype-highlight_index_js":"b590869010da0f115b4e","node_modules_nextcloud_dialogs_dist_chunks_index-Ly0obkwS_mjs":"3c7692df144a0059ef13","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CSmrMOEO_mjs":"29669213052c1f265e89"}[chunkId] + "";
};